import { render, staticRenderFns } from "./TranslatorPaymentsList.vue?vue&type=template&id=1b617a12&"
import script from "./TranslatorPaymentsList.vue?vue&type=script&lang=js&"
export * from "./TranslatorPaymentsList.vue?vue&type=script&lang=js&"
import style0 from "./TranslatorPaymentsList.vue?vue&type=style&index=0&id=1b617a12&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports